import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const EnterFirstBalanceModalWrap = styled.div`
	display: grid;
	gap: 1.25em;
	margin-top: 0.43em;
`
EnterFirstBalanceModalWrap.displayName = 'EnterFirstBalanceModalWrap'

export const EnterFirstBalanceModalText = styled.div`
	color: ${colorTheme.enterFirstBalanceModal.text};
	text-align: center;
	font-size: 1.25em;
	font-weight: 600;
	font-family: ${theme.fontRobotoMedium};
`
EnterFirstBalanceModalText.displayName = 'EnterFirstBalanceModalText'

export const EnterFirstBalanceModalContent = styled.div`
	display: grid;
	gap: 0.93em;
`
EnterFirstBalanceModalContent.displayName = 'EnterFirstBalanceModalContent'

export const ErrorMessageWrap = styled.div`
	display: flex;
	padding: 1.25em;
	align-items: flex-start;
	gap: 0.63em;
	border-radius: 0.75em;
	border: 1px dashed ${colorTheme.enterFirstBalanceModal.message.border};
	background: ${colorTheme.enterFirstBalanceModal.message.background};

	> svg {
		width: 1.5em;
		height: 1.5em;
		flex-shrink: 0;
		fill: ${colorTheme.enterFirstBalanceModal.message.icon};
	}
`
ErrorMessageWrap.displayName = 'ErrorMessageWrap'

export const ErrorMessageText = styled.div`
	color: ${colorTheme.enterFirstBalanceModal.message.text};
	font-family: ${theme.fontRobotoMedium};
	font-size: 1em;
	font-weight: 500;
	text-align: left;
`
ErrorMessageText.displayName = 'ErrorMessageText'
